import type { AxiosError } from 'axios';

export function getFormErrors<T>(
  error: AxiosError<ValidationErrors<T>>,
  messages: { permissionMessage: string; fallbackMessage: string }
): ValidationErrors<T> {
  if (error.response?.status === 400) return error.response.data;
  return {
    non_field_errors: [
      error.response?.status === 403
        ? messages.permissionMessage
        : messages.fallbackMessage,
    ],
  } as ValidationErrors<T>;
}
